module.exports = __webpack_public_path__ + "static/media/LoriWaltenburyPhoto_R6_0819.6a9ce4d9.jpg";